<template>
  <div
    class="flex gap-2 rounded-md border border-solid bg-gray-700 px-2.5 py-1.5"
    :class="[
      title ? 'items-start' : 'items-center',
      {
        'border-gray-500': variant === 'info',
        'border-accent-3': variant === 'warning',
        'border-destructive-2': variant === 'error',
      },
    ]"
    :data-testid="dataTestid"
  >
    <svg
      v-if="variant === 'warning'"
      class="h-4 w-4 shrink-0 text-accent-3"
      :class="{ 'mt-0.5': title }"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.5 15 14H1L8 1.5Z"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linejoin="round"
      />
      <path
        d="M8 6v3.5"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <circle cx="8" cy="11.75" r="0.8" fill="currentColor" />
    </svg>
    <svg
      v-else-if="variant === 'error'"
      class="h-4 w-4 shrink-0 text-destructive-2"
      :class="{ 'mt-0.5': title }"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.75C13.8555 2.75 17 5.89453 17 9.75C17 13.6328 13.8555 16.75 10 16.75C6.11719 16.75 3 13.6328 3 9.75C3 5.89453 6.11719 2.75 10 2.75ZM10 15.4375C13.1172 15.4375 15.6875 12.8945 15.6875 9.75C15.6875 6.63281 13.1172 4.0625 10 4.0625C6.85547 4.0625 4.3125 6.63281 4.3125 9.75C4.3125 12.8945 6.85547 15.4375 10 15.4375ZM10 11.0625C9.61719 11.0625 9.34375 10.7891 9.34375 10.4062V6.90625C9.34375 6.55078 9.61719 6.25 10 6.25C10.3555 6.25 10.6562 6.55078 10.6562 6.90625V10.4062C10.6562 10.7891 10.3555 11.0625 10 11.0625ZM10 11.9922C10.4648 11.9922 10.8477 12.375 10.8477 12.8398C10.8477 13.3047 10.4648 13.6875 10 13.6875C9.50781 13.6875 9.125 13.3047 9.125 12.8398C9.125 12.375 9.50781 11.9922 10 11.9922Z"
        fill="currentColor"
      />
    </svg>
    <svg
      v-else
      class="h-4 w-4 shrink-0 text-gray-100"
      :class="{ 'mt-0.5': title }"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        stroke="currentColor"
        stroke-width="1.3"
      />
      <path
        d="M8 7.25v3.5"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <circle cx="8" cy="5.25" r="0.8" fill="currentColor" />
    </svg>
    <div class="min-w-0 font-inter text-xs leading-4 text-gray-50">
      <p v-if="title" class="mb-1 font-semibold">{{ title }}</p>
      <div
        class="font-regular"
        :class="variant === 'error' ? 'text-destructive-2' : 'text-gray-100'"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    variant?: "info" | "warning" | "error";
    title?: string;
    dataTestid?: string;
  }>(),
  { variant: "info" },
);
</script>
